var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      staticClass: "dialogBox",
      attrs: {
        title: "选择直播间",
        width: "1200px",
        loading: _vm.sureLoading,
        top: _vm.top,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "selectLiveRoomScript" }, [
        _c(
          "div",
          { staticClass: "filterHeader" },
          [
            _c("span", { staticClass: "formLabel" }, [_vm._v("直播间名称")]),
            _c(
              "el-input",
              {
                staticStyle: { width: "300px" },
                attrs: {
                  placeholder: `请输入学员${
                    { liveRoomName: "直播间名称", liveRoomCode: "直播间ID" }[
                      _vm.search.liveRoom.label
                    ]
                  }`,
                  clearable: "",
                },
                model: {
                  value: _vm.search.liveRoom.value,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.search.liveRoom,
                      "value",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "search.liveRoom.value",
                },
              },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "120px" },
                    attrs: { slot: "prepend", placeholder: "请选择" },
                    slot: "prepend",
                    model: {
                      value: _vm.search.liveRoom.label,
                      callback: function ($$v) {
                        _vm.$set(_vm.search.liveRoom, "label", $$v)
                      },
                      expression: "search.liveRoom.label",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "直播间名称", value: "liveRoomName" },
                    }),
                    _c("el-option", {
                      attrs: { label: "直播间ID", value: "liveRoomCode" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "formLabel",
                staticStyle: { "margin-left": "20px" },
              },
              [_vm._v("直播模式")]
            ),
            _c("m-select", {
              staticStyle: { width: "270px" },
              attrs: { "dict-key": "LIVE_MODE_OPTION", all: true },
              model: {
                value: _vm.search.liveModel,
                callback: function ($$v) {
                  _vm.$set(_vm.search, "liveModel", $$v)
                },
                expression: "search.liveModel",
              },
            }),
            _c(
              "span",
              {
                staticClass: "formLabel",
                staticStyle: { "margin-left": "20px" },
              },
              [_vm._v("直播状态")]
            ),
            _c("m-select", {
              staticStyle: { width: "270px" },
              attrs: { "dict-key": "LIVE_STATE_OPTION" },
              model: {
                value: _vm.search.status,
                callback: function ($$v) {
                  _vm.$set(_vm.search, "status", $$v)
                },
                expression: "search.status",
              },
            }),
            _c(
              "div",
              { staticStyle: { "margin-top": "10px" } },
              [
                _c("m-select", {
                  staticClass: "mySelect",
                  staticStyle: { "max-width": "115px", "margin-right": "-3px" },
                  attrs: { clearable: false, "dict-key": "TIME_LIVE_TYPE" },
                  model: {
                    value: _vm.search.time.label,
                    callback: function ($$v) {
                      _vm.$set(_vm.search.time, "label", $$v)
                    },
                    expression: "search.time.label",
                  },
                }),
                _c("el-date-picker", {
                  staticClass: "input-with-time",
                  attrs: {
                    size: "small",
                    type: "daterange",
                    "value-format": "yyyy-MM-dd",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "unlink-panels": true,
                  },
                  on: { change: _vm.handleClickSearch },
                  model: {
                    value: _vm.search.time.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.search.time, "value", $$v)
                    },
                    expression: "search.time.value",
                  },
                }),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "120px", "margin-left": "10px" },
                    attrs: { size: "small", placeholder: "请选择" },
                    on: { change: _vm.onhandleTearchChange },
                    model: {
                      value: _vm.search.teacher.label,
                      callback: function ($$v) {
                        _vm.$set(_vm.search.teacher, "label", $$v)
                      },
                      expression: "search.teacher.label",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "真人IP", value: "realityTeacherUserId" },
                    }),
                    _c("el-option", {
                      attrs: { label: "视频IP", value: "videoTeacherId" },
                    }),
                  ],
                  1
                ),
                _vm.search.teacher.label === "realityTeacherUserId"
                  ? _c("m-select", {
                      staticClass: "select-secord",
                      staticStyle: { width: "200px" },
                      attrs: {
                        clearable: "",
                        remote: "",
                        "reserve-keyword": "",
                        "dict-list": _vm.userArray,
                        placeholder: "请输入关键词",
                        "remote-method": _vm.remoteMethod,
                        param: { value: "userId", label: "userName" },
                      },
                      model: {
                        value: _vm.search.teacher.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.search.teacher, "value", $$v)
                        },
                        expression: "search.teacher.value",
                      },
                    })
                  : _vm._e(),
                _vm.search.teacher.label === "videoTeacherId"
                  ? _c("AppSelect", {
                      staticClass: "filter_teacherSelect",
                      attrs: {
                        "get-api-fn": _vm.getTeacherList,
                        "search-key": "teacherName",
                        value: _vm.search.teacher.value,
                        label: _vm.search.teacherName,
                        props: {
                          label: "teacherName",
                          value: "teacherId",
                        },
                      },
                      on: { selected: _vm.selectedTeacher },
                    })
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    staticClass: "m-l-10",
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.searchFn },
                  },
                  [_vm._v("搜索")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "m-l-10",
                    attrs: { size: "small" },
                    on: { click: _vm.resetFn },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "myTable",
          },
          [
            _c(
              "el-table",
              {
                attrs: {
                  height: "452",
                  "header-cell-style": { background: "#F3F3F3" },
                  data: _vm.list,
                  "row-key": "id",
                },
                on: {
                  "row-click": _vm.rowClick,
                  "selection-change": _vm.handleSelectionChange,
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    width: "55",
                    align: "center",
                    type: "selection",
                    "reserve-selection": true,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("el-checkbox", {
                            attrs: {
                              value: _vm.selectIdsList.includes(row.id),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.rowClick(row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "code", label: "直播间ID", width: "100" },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "直播间名称",
                    prop: "name",
                    "min-width": "120px",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "直播场景",
                    prop: "type",
                    width: "80px",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s({ 1: "正式", 2: "测试" }[row.type]) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "直播类型", width: "80px", prop: "feesType" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(row.feesType === 1 ? "免费" : "付费") +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "直播模式",
                    prop: "liveModel",
                    "min-width": "100px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "liveMode",
                              class: `liveMode${row.liveModel}`,
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("getOptionsValue")(
                                          row.liveModel,
                                          _vm.liveModeOption
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "讲师",
                    prop: "teacherInfoDtoList",
                    "min-width": "120px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("textShowMore", {
                            attrs: {
                              "line-clamp": 1,
                              text: _vm.renderTearch(row),
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "开播时间",
                    prop: "startTime",
                    "min-width": "152px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm
                                  .moment(row.startTime)
                                  .format("YYYY-MM-DD HH:mm:ss")
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "直播状态",
                    prop: "status",
                    "min-width": "114px",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "liveType",
                              class: `liveType${row.status}`,
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("getOptionsValue")(
                                          row.status,
                                          _vm.liveStateOption
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "创建人",
                    prop: "createUserName",
                    "min-width": "114px",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("div", { staticClass: "tipsError" }, [
                  _c("span", { staticClass: "tips" }, [
                    _vm._v("已选" + _vm._s(_vm.selectList.length) + "项"),
                  ]),
                ]),
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total,
                    "pager-count": 5,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "div",
          { staticClass: "ss-material-box-bottom" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.sure },
              },
              [_vm._v("确认")]
            ),
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.closeFn } },
              [_vm._v("取消")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }